// extracted by mini-css-extract-plugin
export default {"node":"styles_node__p-ZTq","content":"styles_content__deHet","header":"styles_header__fp7bv","text":"styles_text__NdWRF","leafletContainer":"styles_leafletContainer__T4VAc"};